import gql from "graphql-tag"

const SEARCH_VENDORS = gql`
  query searchVendors($searchVendorsInput: SearchVendorsInput!) {
    searchVendors(searchVendorsInput: $searchVendorsInput) {
      id
      name
    }
  }
`

export default SEARCH_VENDORS
